<template>
    <nio-modal
        name="sendConfirmation"
        size="md"
        :title="modalTitle"
        ref="modal"
        @closed="onClosed"
        @open="onOpen"
    >
        <message-builder
            appended-message="confirmation"
            :initial-message.sync="message"
            :initial-subject.sync="subject"
            :selected-items="selectedAppointments"
            :show-subject="confirmationType == 'email'"
            ref="messageBuilder"
        />

        <template #footer>
            <nio-button @click="close">
                {{ $t('appointments.sendConfirmationModal.cancel') }}
            </nio-button>
            <nio-button
                color="blue"
                :disabled="!valid"
                @click="onApprove"
            >
                {{ $t('global.general.send') }}
            </nio-button>
        </template>
    </nio-modal>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';
    import MessageParsing from '@/mixins/MessageParsing.js';
    import MessageBuilder from '@/components/MessageBuilder.vue';

    export default {
        components: {
            MessageBuilder,
        },

        mixins: [MessageParsing],

        data() {
            return {
                confirmationType: 'sms',
                message: {
                    fr: '',
                    en: '',
                },
                subject: {
                    fr: '',
                    en: '',
                },
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            ...mapState('appointment', [
                'selectedAppointments',
            ]),

            modalTitle() {
                if (this.confirmationType === 'email') {
                    return this.$t('appointments.sendConfirmationModal.titleEmail');
                }

                return this.$t('appointments.sendConfirmationModal.titleSms');
            },

            valid() {
                if (this.message != null) {
                    if (empty(this.message.fr) &&
                        empty(this.message.en)
                    ) {
                        return false;
                    }
                }

                if (this.confirmationType == 'email' &&
                    this.subject != null &&
                    empty(this.subject.fr) &&
                    empty(this.subject.en)
                ) {
                    return false;
                }

                return true;
            },
        },

        methods: {
            ...mapMutations('appointment', [
                'updateAppointment',
            ]),

            onApprove() {
                this.send();
                this.close();

                this.$nextTick(() => {
                    this.$emit('confirm');
                });
            },

            async send() {
                const messages = [];

                this.message = this.duplicateTranslationIfEmpty(this.message);

                if (this.confirmationType == 'sms') {
                    // Build array of conversation with appropriate body
                    for (const appointment of this.selectedAppointments) {
                        this.updateAppointment({
                            id: appointment.id,
                            sent_sms: true,
                        });

                        messages.push({
                            body: this.fillTemplateValues(this.message[appointment.contact.locale], appointment, 'confirmation'),
                            appointment_id: appointment.id,
                        });
                    }

                    try {
                        await this.$axios.post('messages/mass-send', {
                            account_id: this.authUser.account.id,
                            messages,
                            type: 'sms',
                        });

                        this.$notify.show({
                            type: 'success',
                            message: this.$t('appointments.sendConfirmationModal.sending'),
                        });
                    } catch (error) {
                        this.$notify.show({
                            type: 'error',
                            message: error.response.status === 422 ? error.response.data.message : this.$t('appointments.sendConfirmationModal.sendingFailed'),
                        });
                    }
                } else if (this.confirmationType == 'email') {
                    this.subject = this.duplicateTranslationIfEmpty(this.subject);

                    // Build array of conversation with appropriate body
                    for (const appointment of this.selectedAppointments) {
                        this.updateAppointment({
                            id: appointment.id,
                            sent_email: true,
                        });

                        messages.push({
                            subject: this.fillTemplateValues(this.subject[appointment.contact.locale], appointment),
                            body: this.fillTemplateValues(this.message[appointment.contact.locale], appointment),
                            appointment_id: appointment.id,
                        });
                    }

                    await this.$axios.post('messages/mass-send', {
                        messages,
                        type: 'email',
                    });

                    this.$notify.show({
                        type: 'success',
                        message: this.$t('appointments.sendConfirmationModal.sending'),
                    });
                }
            },

            onClosed() {
                this.$reset();
            },

            onOpen({ confirmationType } = {}) {
                if (confirmationType) {
                    this.confirmationType = confirmationType;
                }
            },

            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>
